import { Link } from "react-router-dom";

export const Brand = ({ dark = false, size = "md", testid = "header-logo" }) => {
  const img = size === "lg" ? "h-14 w-14" : "h-11 w-11";
  return (
    <Link
      to="/"
      data-testid={testid}
      className="group flex items-center gap-3 text-left"
      aria-label="Theotokos · Mater Dei — home"
    >
      <img
        src="/emblem-512.png"
        alt=""
        aria-hidden="true"
        className={`${img} shrink-0 object-contain transition-transform duration-500 group-hover:rotate-[6deg] group-hover:scale-105`}
      />
      <span className="leading-none">
        <span
          className={`block font-serif text-lg font-semibold tracking-[0.12em] sm:text-xl ${
            dark ? "text-ivory" : "text-midnight"
          }`}
        >
          THEOTOKOS
        </span>
        <span className="mt-1 block font-mono text-[9px] uppercase tracking-[0.42em] text-gold sm:text-[10px]">
          Mater Dei · Mother of God
        </span>
      </span>
    </Link>
  );
};
